import { defineSlotRecipe } from '@chakra-ui/react';
import { avatarAnatomy } from '@chakra-ui/react/anatomy';

import {
  avatarEditIconSize,
  avatarEditOverlayBg,
  avatarFontSize,
  avatarSize,
} from './avatar.kds';

const avatarSmallRoot = {
  '--avatar-size': avatarSize.sm,
  '--avatar-font-size': avatarFontSize.sm,
} as const;

const avatarEditableOverlayStyles = {
  '&[data-editable] [data-avatar-edit-overlay]': {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'inherit',
    bg: avatarEditOverlayBg,
    color: 'neutral.0',
    opacity: 0,
    transition: 'opacity 0.15s ease',
    pointerEvents: 'none',
  },
  '&[data-editable]:hover [data-avatar-edit-overlay]': {
    opacity: 1,
  },
  '& [data-avatar-edit-overlay] svg': {
    boxSize: avatarEditIconSize,
  },
} as const;

/** KDS Avatar — circular image or bordered initials fallback; overrides Chakra size only. */
export const avatarSlotRecipe = defineSlotRecipe({
  slots: avatarAnatomy.keys(),
  base: {
    root: {
      bg: 'transparent',
      borderWidth: 0,
    },
    fallback: {
      boxSize: 'full',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bg: 'neutral.0',
      borderWidth: '1px',
      borderColor: 'neutral.100',
      color: 'neutral.500',
    },
  },
  variants: {
    variant: {
      subtle: {
        root: {
          bg: 'transparent',
          color: 'neutral.500',
        },
      },
    },
    size: {
      sm: {
        root: avatarSmallRoot,
      },
      lg: {
        root: {
          '--avatar-size': avatarSize.lg,
          '--avatar-font-size': avatarFontSize.lg,
          ...avatarEditableOverlayStyles,
        },
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});
